import { CURRENCIES } from '../constants'

export const currencySymbol = code => {
  const currency = CURRENCIES[code]
  if(currency) {
    return currency.symbol
  }
  return code
}
